module.exports = __webpack_public_path__ + "static/media/noc-cancel.fw.9bd7929a.png";